import { useEffect, useRef, useState } from "react";
import FacebookSvg from "../../assets/svg/facebookSvg";
import InstagramSvg from "../../assets/svg/instagramSvg";
import SearchSvg from "../../assets/svg/searchSvg";
import TelegramSVg from "../../assets/svg/telegramSvg";
import TwitterSvg from "../../assets/svg/twitterSvg";
import YoutubeSvg from "../../assets/svg/youtubeSvg";
import TikTokSvg from "../../assets/svg/tikTokSvg";
import Header from "../../components/header";
import "./sell.css";
import { InputGroup, Form, ListGroup, Col } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import OutsideClickHandler from "react-outside-click-handler";
import ExportApi from "../../api/ExportApi";
import { Skeleton, Box } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TawkTo from "tawkto-react";

const infoCards = [
    {
        title: "HOW SELLING WORKS",
        content: (
            <div className="justify-content-between">
                <ul className="m-0">
                    <li><p className="text-muted-foreground mb-0"  style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>No listing needed - just pick your model.</p></li>
                    <li><p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>Sell now or set your price (Place Ask).</p></li>
                    <li><p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>Ship within 72 hours (our label).</p></li>
                    <li><p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>We verify, then you get paid.</p></li>
                    <li><p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>You can edit/cancel any Ask before it matches.</p></li>
                </ul>
            </div>
        ),
        link: { href: `${process.env.REACT_APP_REDIRECT_URI}/help/buying-and-Selling-Guide`, text: "Selling Guide & Policies →" },
    },
    {
        title: "PAYOUTS",
        content: (
            <div>
                <ul>
                    <li>
                        <p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>Used: Paid after verification pass.</p>
                    </li>
                    <li>
                        <p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>New: Paid Day 4 after Delivered (signed) if no DOA claim.</p>
                    </li>
                    <li>
                        <p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>Payout is locked at Sell Now/ Place Ask - pass verification and get paid that exact amount.</p>
                    </li>
                </ul>
            </div>
        ),
        link: { href: `${process.env.REACT_APP_REDIRECT_URI}/help/payouts`, text: "Payouts →" },
    },
    {
        title: "QUICK PASS CHECKLIST (USED)",
        content: (
            <div className="d-flex flex-row justify-content-between">
                <div>
                    <p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>Clean & complete</p>
                    <p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>Stock BIOS/clocks</p>
                    <p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>Serial tag visible</p>
                    <p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>No major damage</p>
                </div>
                <div className="px-3 me-5">
                    <p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>Pass benchmark</p>
                    <p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>Temps stable</p>
                    <p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>LEDs & Fans OK</p>
                    <p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>Display ports OK</p>
                </div>
            </div>
        ),
        link: { href: `${process.env.REACT_APP_REDIRECT_URI}/help/quality-standards`, text: "Full Quality Standards →" },
    },
    {
        title: "QUICK PASS CHECKLIST (NEW)",
        content: (
            <div>
                <p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>Factory Sealed</p>
                <p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>MPN/model matches listing</p>
                <p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>Packaging OK</p>
                <p className="text-muted-foreground mb-0" style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }}>Non Tampered</p>
            </div>
        ),
        link: { href: `${process.env.REACT_APP_REDIRECT_URI}/help/quality-standards`, text: "Full Quality Standards →" },
    },
];

const getApiKeyDecode = async () => {
    try {
        const response = await ExportApi.gettawk();
        return response.data;
    } catch (error) {
        console.error("Error fetching API key:", error);
        throw new Error("Failed to retrieve API key");
    }
};

const openTawkToPopup = async () => {
    try {
        const { propertyId, key } = await getApiKeyDecode();
        const tawkToInstance = new TawkTo(propertyId, key);
        tawkToInstance.toggle();
    } catch (error) {
        console.error("Error opening Tawk.to popup:", error);
    }
};

const NewSell = () => {
    const navigate = useNavigate();
    const [searchValue, setSearchValue] = useState("");
    const [searchPopup, setSearchPopUp] = useState(false);
    const divRef = useRef(null);
    const popupRef = useRef(null);
    const [headerHeight, setHeaderHeight] = useState(72);
    const [data, setData] = useState([])
    const [searchLoader, setSearchLoader] = useState(false)
    const location = useLocation();
    const tokenpic = localStorage.getItem("load");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const paramValue = new URLSearchParams(location.search).get("contactus");
        if (paramValue === "true" && tokenpic === "true") {
            openTawkToPopup();
        }
    }, [location.search, tokenpic]);

    useEffect(() => {
        const updateHeaderHeight = () => {
            const header = document.querySelector('.custom-header');
            if (header) {
                setHeaderHeight(header.offsetHeight);
            }
        };
        
        updateHeaderHeight();
        window.addEventListener('resize', updateHeaderHeight);
        
        return () => window.removeEventListener('resize', updateHeaderHeight);
    }, []);

    useEffect(() => {
        function handleClickOutside(event) {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setSearchPopUp(false);   // CLOSE POPUP
            }
        }

        if (searchPopup) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [searchPopup]);


    const handleSearch = async (value) => {
        try {
            setSearchLoader(true);
            const resp = await ExportApi.GetAllProductSerch(value);

            console.log(resp, "RESP")
            if (resp?.data?.success) {
                setData(resp?.data?.Data);
            }
            else {
                setData([]);
            }
        } catch (error) {
            setData([]);
        }
        finally {
            setSearchLoader(false);
        }
    };

    useEffect(() => {

        if (searchValue) {
            setSearchLoader(true)
        }
        const timer = setTimeout(() => {
            handleSearch(searchValue);
        }, 2000);

        return () => clearTimeout(timer);
    }, [searchValue]);

    return (
        <div className="custom-font text-lg min-h-screen">
            <Header showSearchBar={false} />
            <div className="min-h-screen" style={{ 
                borderBottom: "2px solid #BBBBBB", 
                width: "100%",
                height: "1px",
                position: "sticky",
                top: "84px",
                zIndex: 999,
                backgroundColor: "#f5f5f5 !important"
            }}></div>
            <div className="sellNowPage min-h-screen bg-background mt-2 mt-md-4">
                <div className="container px-md-5 px-3">
                    {/* Hero Section */}
                    <div className="mb-8">
                        <h1
                            className="sellHeading mb-2 text-foreground"
                            style={{
                                fontSize: "clamp(1rem, 3vw, 2.2rem)",
                                fontWeight: 600,
                                
                                 textAlign: "left",
                            }}
                        >
                            SELL YOUR GPU AT LIVE MARKET PRICE IN ~30 SECONDS
                        </h1>
                        <p
                            className="text-muted-foreground"
                            style={{
                                fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)",
                                textAlign: "left",
                                fontWeight : 600
                            }}
                        >
                            No listing, No DMs, No haggling. Ship to GPUwiz - we verify and payout
                        </p>
                        <div className="d-flex my-2 gap-2">
                            <div
                                className="border border-dark text-center py-2 flex-grow-1"
                                style={{ borderRadius: "10px", flexBasis: 0 }}
                            >
                                <p
                                    className="text-muted-foreground mb-0"
                                    style={{ fontSize: "clamp(0.65rem, 1.4vw, 1.3125rem)" , color: "#111111" }}
                                 >
                                    GPUwiz seller protection
                                </p>
                            </div>

                            <div
                                className="border border-dark text-center py-2 flex-grow-1"
                                style={{ borderRadius: "10px", flexBasis: 0 }}
                            >
                                <p
                                    className="text-muted-foreground mb-0"
                                    style={{ fontSize: "clamp(0.65rem, 1.4vw, 1.3125rem)" , color: "#111111"  }}
                                >
                                    No buyer drama
                                </p>
                            </div>
                        </div>
                        <p
                            className="text-foreground"
                            style={{
                                fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)", // responsive like before
                                fontWeight: 600,                           // match h1 weight style
                                textAlign: "left",
                                // marginLeft: "67px",
                                color: "#111111",                           // ensures dark text
                            }}
                        >
                            Search model → Sell Now or Place Ask → Ship → Get paid
                        </p>
                    </div>

                    <div style={{ position: "relative", width: "100%", zIndex: 10 }} className={`my-2 d-flex flex-column justify-content-center align-items-center`}>

                        <div className="position-relative w-100">
                            <span className="search-icon-inline">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.018-.014zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                </svg>
                            </span>
                            <Form.Control
                                className="search-input px-md-5 px-3 py-md-3 py-2 ps-md-5 ps-5"
                                style={{ borderRadius: "30px" }}
                                placeholder="Enter exact model or MPN (i.e. MSI RTX 4070 Ventus 2X OC / G470V02X12C)"
                                type="text"
                                value={searchValue}
                                autoComplete="off"
                                onChange={(e) => {
                                    setSearchValue(e.target.value);
                                    setSearchPopUp(true);
                                }}
                                onClick={() => setSearchPopUp(true)}
                            />
                        </div>

                        {searchPopup && searchValue && (
                            <div ref={popupRef} className="pt-5 search-dropdown" style={{ width: isMobile ? '100%' : '100%' }}>
                                <ListGroup style={{ backgroundColor: '#fff', border: "none", height: '100%' }} className="pb-3" as="ul">
                                    {!searchLoader && data?.length > 0 && (
                                        <div className="d-flex justify-content-end align-items-end px-3 py-0">
                                            <p>Total Results : {data.length}</p>
                                        </div>
                                    )}

                                    {
                                        searchLoader ? (
                                            <>
                                                {[...Array(5)].map((_, i) => (
                                                    <ListGroup.Item className="search-list" key={i}>
                                                        <div className="d-flex align-items-center gap-5">
                                                            {/* Skeleton for Image */}
                                                            <Box sx={{ width: 100, height: 100 }}>
                                                                <Skeleton variant="rectangular" width={"100%"} height={"100%"} sx={{ borderRadius: "8px" }} />
                                                            </Box>

                                                            {/* Skeleton for Text */}
                                                            <div className="custom-list w-100">
                                                                <Skeleton variant="text" width="50%" height={22} />
                                                                <Skeleton variant="text" width="75%" height={22} />
                                                                <Skeleton variant="text" width="60%" height={22} />
                                                                <Skeleton variant="text" width="40%" height={20} />
                                                            </div>
                                                        </div>
                                                    </ListGroup.Item>
                                                ))}
                                            </>
                                        ) : data?.length > 0 ?
                                            (
                                                <>
                                                    {data?.map((val, i) => (
                                                        <ListGroup.Item 
                                                            className="search-list" 
                                                            key={i}
                                                            onClick={() => {
                                                                localStorage.setItem('activeTab' , "ask")
                                                                navigate(`/bidask/${val?.slug}`);
                                                                setSearchPopUp(false);
                                                                setSearchValue("");
                                                                setData([]);
                                                            }}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <div className="d-flex align-items-center gap-5">
                                                                <LazyLoadImage style={{ maxHeight: '100px', maxWidth: '100px' }} src={val.image[0] ?? ""} alt={val.model ?? ""} />
                                                                <div className="custom-list">
                                                                    <p className="mb-0" style={{ fontSize: '14px', lineHeight: '14px' }}>{val.brand ?? ""}</p>
                                                                    <h3 style={{ fontSize: '14px', lineHeight: '14px' }}>{val.series ?? ""}</h3>
                                                                    <h3 style={{ 
                                                                        fontWeight: 'normal', 
                                                                        fontSize: '12.6px', 
                                                                        lineHeight: '12.6px', 
                                                                        whiteSpace: 'normal', 
                                                                        overflow: 'hidden', 
                                                                        marginTop: '5px'
                                                                    }}>{val.model ?? ""}</h3>
                                                                    <h5 style={{ color: "#0b4068", fontSize: '12.6px', lineHeight: '12.6px', fontWeight: 'bold', marginTop: '3px' }}>
                                                                        Condition:{" "}
                                                                        {val.type == 1 ? "New" : val.type == 2 ? "New(Resale)" : "Used(Tested)"}
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                        </ListGroup.Item>
                                                    ))}
                                                </>
                                            ) : (
                                                <div className="d-flex justify-content-center align-items-center">
                                                    <p style={{ fontSize : "clamp(0.75rem, 1.4vw, 1.3125rem)" ,  color: "#333" }}>
                                                        No results found
                                                    </p>
                                                </div>
                                            )
                                    }

                                </ListGroup>
                            </div>
                        )
                        }

                    </div>

                    <p style={{ zIndex: -2 , fontSize : "clamp(0.75rem, 1.4vw, 1.3125rem)"}} className="searchNote !justify-content-start !align-items-start !mt-0 mb-md-4 mb-2">
                        Can't find it? Check the box label or manufacturers website{" "}
                        <a href="/help/supported-models" className="searchLink">Get Help →</a>
                    </p>    

                    <div className="infoCardsContainer mb-md-5 mb-3 mt-4">
                        {infoCards.map((card, i) => (
                            <div className="infoCard mb-2 mb-md-4" key={i}>
                                <h3 className="infoCardTitle">{card.title}</h3>
                                <div className="infoCardContent">{card.content}</div>
                                {card.link && (
                                    <a href={card.link.href} className="infoCardLink text-decoration-underline">
                                       <p style={{ color: "#ff4400" , fontSize : "clamp(0.75rem, 1.4vw, 1.3125rem)" }}> {card.link.text}</p>
                                    </a>
                                )}
                            </div>
                        ))}
                    </div>

                    <div className="sales-support-bar">
                         <p
                            className="text-muted-foreground sales-text"
                            style={{
                                fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)",
                                textAlign: "left",
                            }}
                        >
                            <strong>Live marketplace note:</strong> If your Ask is accepted (or you use Sell Now),
                            it becomes a real order. Keep only active Asks for items you're ready
                            to ship within 72 hours. You can edit/cancel any Ask anytime before it
                            matches. <a href="/help/buying-and-selling-guide" className="accent-link">How matching works →</a>
                        </p>

                        <button className="chat-btn px-4 text-lg" onClick={openTawkToPopup}>
                            <div className="btn-title">Any Questions?</div>
                            <div className="btn-link">
                                Chat Support{" "}
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    className="inline-block text-[#e03131]"
                                >
                                    <path
                                        fill="#e03131"
                                        d="M10.5 8.5H1.707a.5.5 0 1 1 0-1H10.5 10.293l-3.146-3.146a.5.5 0 1 1 .707-.707l4 4a.5.5 0 0 1 0 .707l-4 4a.5.5 0 0 1-.707-.707L10.293 8.5Z"
                                    />
                                </svg>
                            </div>
                        </button>
                    </div>

                    { }
                    <div className="text-center">
                        <div className="d-flex flex-row justify-content-center gap-2 my-4">
                            <a href="https://www.youtube.com/@gpuwiz" target="_blank" className="text-accent hover:opacity-80">
                                <span style={{ transform: "scale(1.2)", display: "inline-flex" }}>
                                    <YoutubeSvg />
                                </span>
                            </a>
                            <a href="https://twitter.com/gpu_wiz" target="_blank" className="text-accent hover:opacity-80">
                                <span style={{ transform: "scale(1.2)", display: "inline-flex" }}>
                                    <TwitterSvg />
                                </span>
                            </a>
                            <a href="https://www.instagram.com/gpuwiz/" target="_blank" className="text-accent hover:opacity-80">
                                <span style={{ transform: "scale(1.2)", display: "inline-flex" }}>
                                    <FacebookSvg />
                                </span>
                            </a>
                            <a href="https://www.tiktok.com/@gpuwiz?lang=en" target="_blank" className="text-accent hover:opacity-80">
                                <span style={{ transform: "scale(1.2)", display: "inline-flex" }}>
                                    <TikTokSvg />
                                </span>
                            </a>
                            <a href="https://www.facebook.com/profile.php?id=61556017664988" target="_blank" className="text-accent hover:opacity-80">
                                <span style={{ transform: "scale(1.2)", display: "inline-flex" }}>
                                    <InstagramSvg />
                                </span>
                            </a>
                            
                        </div>
                        

                        <h2 className="text-2xl font-bold text-foreground mb-2">more value. more trust. less time.</h2>

                        <div className="footer text-xs text-muted-foreground">
                            <div className="flex justify-center gap-3">
                                <a href="/help/pre-sale-inspection-guide" target="_blank" className="hover:text-accent">Pre-Sale Inspection Guide</a>
                                <span> | </span>
                                <a href="/help/buying-and-Selling-Guide" target="_blank" className="hover:text-accent">Buying & Selling Guide</a>
                                <span> | </span>
                                <a href="/help/quality-standards" target="_blank" className="hover:text-accent">Quality Standards</a>
                            </div>
                            <div className="flex justify-center gap-3">
                                <a href="/cookies" target="_blank" className="hover:text-accent">Cookie Policy</a>
                                <span> | </span>
                                <a href="/PrivacyPolicy" target="_blank" className="hover:text-accent">Privacy</a>
                                <span> | </span>
                                <a href="/terms" target="_blank" className="hover:text-accent">Terms</a>
                                <span> | </span>
                                <button
                                    onClick={openTawkToPopup}
                                    className="text-start bg-none border-0 p-0 d-inline text-dark fs-5 fw-small"
                                    style={{ fontFamily: "panton"}}
                                >
                                   Contact Us
                                </button>
                            </div>
                            <p style={{fontSize : "clamp(0.75rem, 1.4vw, 1.3125rem)"}}>Los Angeles</p>
                            <p style={{fontSize : "clamp(0.75rem, 1.4vw, 1.3125rem)"}}>©2025 GPUwiz | All Rights Reserved</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewSell;